// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-logo[data-v-1d2aa1f3]{cursor:pointer;display:flex;width:100%;fill:var(--color-logo-black)}.the-logo[data-v-1d2aa1f3]:hover{opacity:.9}[data-theme=dark] .the-logo[data-v-1d2aa1f3]{fill:var(--color-white)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
